import { type ContentSelectionMode } from '@databases/redux/cellSelections/selectors';

type GetTotalSelectedCountPropTypes = {
  selectionMode: ContentSelectionMode;
  selectedEntriesCount: number;
  selectedEntireFieldsCount: number;
  selectedValuesCount: number;
};

export const getTotalSelectedCount = ({
  selectionMode,
  selectedEntriesCount,
  selectedEntireFieldsCount,
  selectedValuesCount,
}: GetTotalSelectedCountPropTypes) => {
  switch (selectionMode) {
    case 'row':
      return selectedEntriesCount;
    case 'column':
      return selectedEntireFieldsCount;
    case 'cell':
      return selectedValuesCount;
    default:
      return 0;
  }
};
